import { render, staticRenderFns } from "./AndamandaStaffListPage.vue?vue&type=template&id=fc0680bc&scoped=true"
import script from "./AndamandaStaffListPage.vue?vue&type=script&lang=js"
export * from "./AndamandaStaffListPage.vue?vue&type=script&lang=js"
import style0 from "./AndamandaStaffListPage.vue?vue&type=style&index=0&id=fc0680bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0680bc",
  null
  
)

export default component.exports